var React = require('react');

function CarouselArrowNext (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.2 16C18.2 16.2666 18.1555 16.5111 18.0667 16.7333C17.9778 16.9555 17.8222 17.1777 17.6 17.4L4.39999 30.6C4.04443 30.9555 3.56666 31.1222 2.96666 31.1C2.36666 31.0777 1.88888 30.8889 1.53332 30.5333C1.08888 30.0889 0.89999 29.6111 0.966657 29.1C1.03332 28.5889 1.24444 28.1333 1.59999 27.7333L13.3333 16L1.59999 4.26663C1.24444 3.91108 1.04443 3.4333 0.99999 2.8333C0.955545 2.2333 1.15555 1.75552 1.59999 1.39997C1.95555 0.955521 2.42221 0.766632 2.99999 0.8333C3.57777 0.899965 4.06666 1.11107 4.46666 1.46663L17.6 14.6C17.8222 14.8222 17.9778 15.0444 18.0667 15.2666C18.1555 15.4889 18.2 15.7333 18.2 16Z","fill":"#AAAAAA"}));
}

CarouselArrowNext.defaultProps = {"width":"19","height":"32","viewBox":"0 0 19 32","fill":"none"};

module.exports = CarouselArrowNext;

CarouselArrowNext.default = CarouselArrowNext;
